import { defineStore } from "pinia";
import { ref, computed } from "vue";

import { updateSettings } from "../api/updateSettings";

// Текстовый символ валюты по её коду — для подстановки строкой в карточках
// и гридах (suffix, шаблонные литералы), где нужен символ, а не компонент-иконка.
const CURRENCY_SYMBOLS = {
    RUB: "₽",
    USD: "$",
    EUR: "€",
    UAH: "₴",
    BYN: "Br",
    KZT: "₸",
    YTL: "₺",
    HRK: "kn",
    IDR: "Rp",
    AED: "dh",
    CNY: "¥",
    THB: "฿",
    GEL: "₾",
    ILS: "₪",
    UZS: "soʻm",
    AZN: "₼",
};

export const useSettingsStore = defineStore("SettingsStore", () => {
    const settings = ref(null);
    const token = ref(null);

    const setSettings = function (s) {
        settings.value = s;
    };

    const setToken = function (t) {
        token.value = t;
    };

    const saveChanges = async function () {
        await updateSettings(settings.value);
    };

    const currencyConst = computed(() => {
        return settings.value?.currency?.const;
    });

    // Символ валюты директора (по умолчанию ₽, пока настройки не загружены).
    const currencySymbol = computed(() => {
        return CURRENCY_SYMBOLS[currencyConst.value] ?? "₽";
    });

    return {
        settings,
        token,
        setToken,
        setSettings,
        saveChanges,
        currencyConst,
        currencySymbol,
    };
});
